(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return '\u00A5' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function updateBars(totalCents) {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;

      var remaining = threshold - totalCents;
      var pct = Math.min(100, Math.floor((totalCents / threshold) * 100));

      var fill = bar.querySelector('[data-free-shipping-fill]');
      var text = bar.querySelector('[data-free-shipping-text]');

      if (fill) fill.style.width = pct + '%';

      if (text) {
        if (remaining <= 0) {
          text.innerHTML = '送料無料まで到達しました！';
        } else {
          text.innerHTML = 'あと<strong>' + formatMoney(remaining) + '</strong>で送料無料';
        }
      }
    });
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    updateBars(cart.total_price);
  });
})();
